import Vue from 'vue'
import baseTools from './utils/comFun'
// 限制输入带两位小数点金额指令
Vue.directive('num', {
  inserted(el, bind) {
    let params = bind.value || {}
    const trigger = (el, type) => {
      const e = document.createEvent('HTMLEvents')
      e.initEvent(type, true, true)
      el.dispatchEvent(e)
    }
    el.addEventListener('keyup', function(e) {
      const input = e.target
      if (!/((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/.test(input.value)) {
        input.value = ''
      }
      if (params.min !== '' && params.max !== '') {
        let value = parseFloat(input.value)
        if (value < params.min || value > params.max) {
          input.value = ''
        }
      }
      trigger(input, 'input')
    })
    el.addEventListener('blur', function(e) {
      const input = e.target
      if (input.value) {
        input.value = parseFloat(input.value)
        trigger(input, 'input')
      }
    })
  },
})
// 限制输入带两位小数点正负数
Vue.directive('normal', {
  inserted(el) {
    const trigger = (el, type) => {
      const e = document.createEvent('HTMLEvents')
      e.initEvent(type, true, true)
      el.dispatchEvent(e)
    }
    el.addEventListener('keyup', function(e) {
      const input = e.target
      if (!/^([-?[0-9]{0,1}|[0-9])+\.?[0-9]{0,2}$/.test(input.value)) {
        input.value = ''
      }
      trigger(input, 'input')
    })
    el.addEventListener('blur', function(e) {
      const input = e.target
      if (input.value) {
        input.value = parseFloat(input.value)
        trigger(input, 'input')
      }
    })
  },
})
// 限制输入带三位小数点正数
Vue.directive('dotthird', {
  inserted(el) {
    const trigger = (el, type) => {
      const e = document.createEvent('HTMLEvents')
      e.initEvent(type, true, true)
      el.dispatchEvent(e)
    }
    el.addEventListener('keyup', function(e) {
      const input = e.target
      if (!/^([[0-9]{0,1}|[0-9])+\.?[0-9]{0,3}$/.test(input.value)) {
        input.value = ''
      }
      trigger(input, 'input')
    })
    el.addEventListener('blur', function(e) {
      const input = e.target
      if (input.value) {
        input.value = parseFloat(input.value)
        trigger(input, 'input')
      }
    })
  },
})

// 限制输入大于等于0的整数
Vue.directive('int', {
  inserted(el) {
    const trigger = (el, type) => {
      const e = document.createEvent('HTMLEvents')
      e.initEvent(type, true, true)
      el.dispatchEvent(e)
    }
    el.addEventListener('keyup', function(e) {
      const input = e.target
      if (parseInt(input.value) === 0) {
        input.value = 0
      } else if (/^0+/.test(input.value)) {
        // 01000
        input.value = input.value.replace(/^0+/, '')
      } else {
        input.value = input.value.replace(/\D/g, '')
      }
      trigger(input, 'input')
    })
    el.addEventListener('blur', function(e) {
      const input = e.target
      if (input.value) {
        input.value = parseInt(input.value)
        trigger(input, 'input')
      }
    })
  },
})

// 限制输入框输入，包括最大/最小值、小数点等情况
Vue.directive('input', {
  inserted(el, binding) {
    let params = binding.value || {}
    const trigger = (el, type) => {
      // const e = document.createEvent('HTMLEvents')
      // e.initEvent(type, true, true)
      const e = new CustomEvent(type, {
        bubbles: true, // 事件是否冒泡
        cancelable: true, // 是否可取消
        detail: {
          Manual: true,
        }, //
      })
      el.dispatchEvent(e)
    }
    el.addEventListener('input', function(e) {
      if (!e.detail || (e.detail && !e.detail.Manual)) {
        baseTools.handleNumberInput(e.target, 'value', params.min, params.max, params.other)
        trigger(e.target, 'input')
      }
    })
    if (params.other && params.other.decimals) {
      el.addEventListener('blur', function(e) {
        baseTools.handleNumberBlur(e.target, 'value', params.min, params.max, params.other)
        trigger(e.target, 'input')
      })
    }
  },
})



// WEBPACK FOOTER //
// ./src/directives.js